import { Story } from '../../DocTypes';

export const buttonClickWithDataStory: Story = {
  title: 'Buttons click with data',
  description:
    'Templated list with buttons that when clicked get access to the row of data in the list',
  coreComponent: {
    html: `<tag-list>
    <template>
      <div style="display: flex; align-items: center; padding: 10px;">
        <div style="width: 120px;">
          <tag-text type="feature" text="{{name}}"></tag-text>
        </div>
        <div style="width: 60px;">
          <tag-badge value="{{score}}" accent="tango"></tag-badge>
        </div>
        <tag-button icon="ArrowRight" rounded button-click-include='{"name": "{{name}}", "score": "{{score}}"}'></tag-button>
      <div>
    </template>
  </tag-list>`,
    js: `var tagList = document.querySelector('tag-list');
tagList.componentOnReady().then(function() {
  tagList.setData([
    {
      name: 'Jordan Norry',
      score: 80
    },
    {
      name: 'Sarah Young',
      score: 95
    },
    {
      name: 'Susan Warmly',
      score: 75
    }
  ]);
});
tagList.addEventListener("buttonClick", function (e) {
  var data = JSON.parse(e.target.data);
  alert("The name you clicked was " + data.name);
});
  `,
  },
  reactWrapper: {
    jsx: `<TagList
    renderItem={({name, score}) => (
      <div style={{display: "flex", alignItems: "center", padding: "10px"}}>
        <div style={{width: "120px"}}>
          <TagText type="feature" text={name} />
        </div>
        <div style={{width: "60px"}}>
          <TagBadge value={score} accent="tango" />
        </div>
        <TagButton
          icon="ArrowRight"
          rounded
          onButtonClick={() =>  alert("The name you clicked was " + name)}
        />
      </div>
    )}
    data={[
      {
        name: 'Jordan Norry',
        score: 80
      },
      {
        name: 'Sarah Young',
        score: 95
      },
      {
        name: 'Susan Warmly',
        score: 75
      }
    ]}
  />`,
  },
};
